import { useCallback, useEffect, useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import {
  Divider,
  IconButton,
  InputAdornment,
  Stack,
  Grid,
  Typography,
} from "@mui/material";
import NewsCard from "components/news/NewsCard";
import { getArticleRequest, getCategoryNewsRequest } from "api/requests";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import NotFound from "components/shared/NotFound/NotFound";
import { NEWS_PAGINATION_LIMIT } from "constants";
import MenuCM from "components/shared/menu";
import FooterCM from "components/shared/footer";
import Container from "@mui/material/Container";
import PaginationCM from "components/shared/Pagination";
import ContactCM from "components/contactus";
import {
  StyledTextField,
  StyledRightIcon,
  CategoryList,
  BorderTop,
  StyledButton,
  StyledSticky,
} from "./News.style";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import {Helmet} from "react-helmet";

export default function News() {
  const navigate = useNavigate();
  const [article, setArticle] = useState({ data: [], count: 0 });
  const { request, loading } = useHttp();
  const [page, setPage] = useState(1);
  const [frame, setFrame] = useState({ data: [], count: 0 });
  const [searchValue, setSearchValue] = useState("");
  const [selectedCategory, setSelectedCategory] = useState({
    id: "",
    category: "همه مقالات",
  });

  const getArticle = async (value) => {
    let id = value.id ?? "";
    if (id === undefined || id === "") {
      setSelectedCategory({ id, title: "همه مقالات" });
    } else {
      setPage(1);
      setSelectedCategory({ id, title: value.title });
    }
    const res = await request({
      url: getArticleRequest,
      values: {
        skip: (page - 1) * NEWS_PAGINATION_LIMIT,
        limit: NEWS_PAGINATION_LIMIT,
        search: searchValue,
        id: id,
      },
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      title: items.title,
      file: items.file,
      text: items.text,
      file_type: items.file_type,
      created_at: items.created_at,
    }));

    setArticle({ data: transformedData, count: res.count });
  };

  const getArticleWithoutFilter = async (value) => {
    setSearchValue("");
    let id = "";
    setSelectedCategory({ id, title: "همه مقالات" });

    const res = await request({
      url: getArticleRequest,
      values: {
        skip: (page - 1) * NEWS_PAGINATION_LIMIT,
        limit: NEWS_PAGINATION_LIMIT,
      },
    });

    let transformedData = res.data.map((items) => ({
      id: items.id,
      title: items.title,
      file: items.file,
      text: items.text,
      file_type: items.file_type,
      created_at: items.created_at,
    }));

    setArticle({ data: transformedData, count: res.count });
  };

  const getFrame = useCallback(async () => {
    const res = await request({
      url: getCategoryNewsRequest,
      values: { skip: (page - 1) * 50, limit: 50 },
    });

    if (res) {
      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items.title,
      }));

      setFrame({ data: transformedData, count: res.count });
    }
  }, [request]);

  useEffect(() => {
    getArticle({ id: "", title: "همه مقالات" });
    getFrame();
  }, [page]);

  return (
    <Fragment>
      <Helmet>
        <title>اطلاعات تولید - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <MenuCM pageTitle="اطلاعات تولید" />
          <Container>
            <Grid container my={2} spacing={1}>
              <>
                <Grid item lg={4} md={4} sm={12} xs={12}>
                  <StyledSticky>
                    <StyledTextField
                      variant="outlined"
                      label="جست و جو"
                      size="small"
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <Stack direction="row" alignItems="center">
                              <IconButton
                                edge="end"
                                onClick={() => {
                                  getArticleWithoutFilter();
                                }}
                                sx={{ mr: 0 }}
                              >
                                <CloseIcon />
                              </IconButton>
                              <Divider
                                orientation="vertical"
                                variant="middle"
                                flexItem
                              />
                              <IconButton edge="end" onClick={getArticle}>
                                <SearchIcon />
                              </IconButton>
                            </Stack>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <CategoryList>
                      <BorderTop />
                      <Typography
                        variant="body2"
                        color="primary"
                        fontWeight="bold"
                        mt={2}
                        mb={2}
                      >
                        <span style={{ fontSize: "18px" }}>
                          دسته بندی مقالات
                        </span>
                      </Typography>
                      <StyledButton
                        onClick={() => {
                          setPage(1);
                          getArticle({ id: "", title: "همه مقالات" });
                        }}
                        selected={selectedCategory.id === ""}
                      >
                        همه مقالات
                      </StyledButton>
                      {frame.data.map((item, index) => (
                        <StyledButton
                          key={index}
                          onClick={() => {
                            // setPage(1);
                            getArticle({
                              id: item.id,
                              title: item.title,
                            });
                          }}
                          selected={selectedCategory.id === item.id}
                        >
                          {item.title}
                        </StyledButton>
                      ))}
                    </CategoryList>
                  </StyledSticky>
                </Grid>
                <Grid item lg={8} md={8} sm={12} xs={12}>
                  {article.data.length < 1 ? (
                    <NotFound title="مقاله یافت نشد" />
                  ) : (
                    <>
                      <NewsCard
                        rows={article.data}
                        click={(articleId) => "/article/" + articleId}
                      />
                      <Grid item xs={12}>
                        <PaginationCM
                          handleChange={(e, val) => setPage(val)}
                          page={page}
                          limit={NEWS_PAGINATION_LIMIT}
                          count={article.count}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </>
            </Grid>
          </Container>
          <ContactCM All />
          <FooterCM />
        </Fragment>
      )}
    </Fragment>
  );
}
